// extracted by mini-css-extract-plugin
module.exports = {"root":"outlined-button_root__FoVZ3"};